export const APP_NAME = 'My Notes';
